#import "../fragments/queued-email-fragment.graphql"

mutation SendNowQueuedEmail($payload: EmailQueuedSendNowInput!) {
    emailQueuedSendNow(input: $payload) {
        emailSequence {
            emailsQueued {
                ...QueuedEmail
            }
        }
    }
}
